import { useEffect, useState } from "react";
import { apiConfig } from "../../API/config";

const REACHABILITY_TIMEOUT_MS = 5000;

/**
 * Probes the CNC GraphQL endpoint for reachability. Returns `true` once the
 * endpoint responds (any HTTP status counts as reachable), and `false` while it
 * hasn't responded yet or when the request fails at the network level.
 */
const useCncReachable = (): boolean => {
  const [cncReachable, setCncReachable] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    const timeoutId = setTimeout(
      () => controller.abort(),
      REACHABILITY_TIMEOUT_MS
    );
    let active = true;

    fetch(apiConfig.GRAPHQL_SERVER_CNC, {
      method: "GET",
      mode: "no-cors",
      cache: "no-store",
      signal: controller.signal,
    })
      .then(() => {
        if (active) {
          setCncReachable(true);
        }
      })
      .catch(() => {
        if (active) {
          setCncReachable(false);
        }
      })
      .finally(() => clearTimeout(timeoutId));

    return () => {
      active = false;
      clearTimeout(timeoutId);
      controller.abort();
    };
  }, []);

  return cncReachable;
};

export default useCncReachable;
